exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#record-print-preview[data-v-2757cf38]{display:none}", "", {"version":3,"sources":["/home/www/deploy/school/src/views/record/record-print.vue"],"names":[],"mappings":"AACA,uCACE,YAAc,CACf","file":"record-print.vue","sourcesContent":["\n#record-print-preview[data-v-2757cf38] {\n  display: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2757cf38","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/record/record-print.vue
// module id = YPjx
// module chunks = 11 20 21 33